/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useI18n } from "hooks/i18n/i18n";
import React from "react";

import { LoaderLayout } from "../../components/atoms/loader/LoaderLayout";
import { useAccountsLogout } from "./useAccountsLogout";

/**
 * accounts のログイン状態を落とす
 *
 * ユーザーの操作は挟まない。戻り先へ進めないときだけ結果を伝える。
 */
export const AccountsLogout: React.FC = () => {
  const { t } = useI18n();
  const status = useAccountsLogout();

  /** 失敗を成功と伝えない。ログインが残っていることに気付けないほうが危ない */
  if (status === "error") {
    return <p>{t("auth.error")}</p>;
  }

  if (status === "done") {
    return <p>{t("auth.loggedOut")}</p>;
  }

  return <LoaderLayout />;
};
